import { graphql } from "api/cms-website/generated";

export const VerticalAdvantagesFragment = graphql(/* GraphQL */ `
    fragment VerticalAdvantagesFragment on ComponentComponentsVerticalAdvantages {
        id
        noMarginBottom
        VerticalAdvantagesTitle: title
        VerticalAdvantagesSubtitle: subtitle
        VerticalAdvantagesCta: cta {
            ...ButtonFragment
        }
        VerticalAdvantagesImage: image {
            ...ResponsiveImageFragment
        }
        VerticalAdvantagesItems: advantages {
            ...VerticalAdvantagesItemFragment
        }
    }
`);
